export default "__VITE_ASSET__e4ecc1ee__"